import axios from "axios";
import {
  bffGetUserByAccessToken,
  bffStudentAuth,
  isSelfLearningBffEnabled,
  unwrapBff,
} from "./self_learning_bff";

const WIZ_ME_BFF_URL = process.env.REACT_APP_SELF_LEARNING_BFF_URL;

function extractWizmeId(response) {
  let payload = unwrapBff(response);
  if (payload && !payload.id && payload.data) payload = payload.data;
  return (payload && payload.id) || null;
}

// BFF enabled: POST /api/student/auth with the IES accessToken only. The IES `code` was already
// exchanged by iesLogin (single use), so it must not be sent again. /wizme/user is the fallback.
async function getWizmeIdFromBff(accessToken) {
  try {
    const wizmeId = extractWizmeId(await bffStudentAuth({ accessToken }));
    if (wizmeId) return wizmeId;
    console.warn("[WizmeBFF] /api/student/auth returned no user id, trying /wizme/user");
  } catch (error) {
    console.warn(
      "[WizmeBFF] /api/student/auth failed, trying /wizme/user:",
      (error && error.response && error.response.data) || (error && error.message),
    );
  }
  return extractWizmeId(await bffGetUserByAccessToken(accessToken));
}

/**
 * Retrieves the student's Wizme ID using the IES access_token.
 *
 * @param {string} accessToken - The access_token returned by iesLogin.
 * @returns {Promise<string|null>} The student's Wizme ID (platformId), or null on failure.
 */
export async function getWizmeIdFromIESCode(accessToken) {
  if (!isSelfLearningBffEnabled() && !WIZ_ME_BFF_URL) {
    console.error("[WizmeBFF] REACT_APP_SELF_LEARNING_BFF_URL not set.");
    return null;
  }

  try {
    if (isSelfLearningBffEnabled()) {
      return await getWizmeIdFromBff(accessToken);
    }

    const response = await axios.post(
      `${WIZ_ME_BFF_URL}/wizme/user`,
      {
        accessToken,
      },
      {
        headers: {
          "x-api-key": process.env.REACT_APP_SELF_LEARNING_BFF_URL_API_KEY,
        },
      },
    );

    return extractWizmeId(response);
  } catch (error) {
    console.warn(
      "[WizmeBFF] Could not retrieve Wizme user:",
      (error && error.response && error.response.data) || error.message,
    );
    return null;
  }
}
